import React, { Component } from 'react';
import style from './style.css'

import { Col } from '../../atoms/Grid'
import Avatar from '../../atoms/Avatar'
import FontIcon from '../../atoms/FontIcon'
import { date, dateHour } from '../../../libraries/Formatter'

class CommentForum extends Component {
    render(){
        return(
            <Col size={12} className={`${style.comment}`}>
                <div className={`${style.avatarwrap}`}>
                    <Avatar size={35} img={this.props.data.user_avatar_path} />
                </div>
                <h4>{this.props.data.user_name}</h4>
                { this.props.data.create_at && (
                    <span style={{fontSize: '10px'}}>{date(this.props.data.create_at.split(' ')[0]).br} - {dateHour(this.props.data.create_at.split(' ')[1])}</span>
                )}

                    <div style={{
                        position: 'absolute',
                        right: '0'
                    }}>
                        
                        {this.props.data.is_admin === "1" &&  (
                            <span className={style.iconDelete} onClick={ () => this.props.handleDelete(this.props.data.id)}>
                                <FontIcon name='trash' size={12}/>
                            </span>
                        )}

                    </div>
                <p>{this.props.data.content}</p>
            </Col>
        )
    }
}

export default CommentForum;


// WEBPACK FOOTER //
// ./src/components/molecules/CommentForum/index.js